export default "__VITE_ASSET__r37HWEjU__"